module.exports = __webpack_public_path__ + "img/shopping-bag.04a85bc9.svg";